"use client";

import clsx from "clsx";

export default function GoogleMapCard({ src, width = "100%", height = "432px", title = "Google Map", className = "", classNameIframe = "" }) {
  
  return (
    <div className={`w-full ${className}`} style={{ width, height }}>
      <iframe
        className={clsx("w-full h-full border-0 rounded-lg", classNameIframe)}
        src={src}
        title={title}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
